// Grid of product SKUs (countertops or storages), styled per the Vanity UI spec:
// clean image tiles, no captions, thin border on the selected tile.
// `noStorageTile` renders a leading text-only "No Storage" option.

function ProductCard({ item, selected, onClick, showLabel }) {
  return (
    <button
      onClick={onClick}
      title={item.name || item.id}
      className="flex flex-col items-center gap-1.5 w-full"
    >
      <div
        className={`w-full aspect-square overflow-hidden border transition-colors flex items-center justify-center ${
          selected
            ? "border-gray-300 bg-gray-100"
            : "border-transparent hover:border-gray-300"
        }`}
      >
        <img
          src={item.thumbnail}
          alt={item.name || item.id}
          className="w-full h-full object-contain"
          onError={(e) => {
            e.currentTarget.style.visibility = "hidden";
          }}
        />
      </div>
      {showLabel && (
        <span className="text-[11px] text-gray-500 text-center leading-tight line-clamp-2">
          {item.label ?? item.id}
        </span>
      )}
    </button>
  );
}

function NoStorageCard({ selected, onClick }) {
  return (
    <button onClick={onClick} className="flex flex-col items-center w-full">
      <div
        className={`w-full aspect-square flex items-center justify-center border transition-colors ${
          selected ? "border-gray-300 bg-gray-100" : "border-transparent hover:border-gray-300"
        }`}
      >
        <span className="text-sm text-gray-700 text-center leading-snug">
          No
          <br />
          Storage
        </span>
      </div>
    </button>
  );
}

export default function ProductGrid({
  items,
  selectedId,
  onSelect,
  cols = 3,
  showNoStorage = false,
  noStorageSelected = false,
  onSelectNoStorage,
  showLabels = false,
  emptyMessage,
}) {
  const gridClass = { 3: "grid-cols-3", 4: "grid-cols-4" }[cols] ?? "grid-cols-3";

  if (!showNoStorage && items.length === 0) {
    return (
      <p className="text-xs text-gray-400 px-5 py-6 text-center">
        {emptyMessage ?? "No options available."}
      </p>
    );
  }

  return (
    <div className={`grid ${gridClass} gap-x-4 gap-y-5 px-5 py-5`}>
      {showNoStorage && (
        <NoStorageCard selected={noStorageSelected} onClick={onSelectNoStorage} />
      )}
      {items.map((item) => (
        <ProductCard
          key={item.id}
          item={item}
          selected={selectedId === item.id}
          onClick={() => onSelect(item)}
          showLabel={showLabels}
        />
      ))}
    </div>
  );
}
